import { createFileRoute } from "@tanstack/react-router";
import { MellanoLuukkuPaintingRoundDefectsView } from "src/tenantCustomizations/tenants/mellano/views/luukku/production/MellanoLuukkuPaintingRoundDefectsView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/paintingRoundDefects")({
	staticData: { title: "Maalauskierros, määrä ja viat", legacyViewKey: "mellanoLuukkuPaintingRoundDefectsView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLuukkuPaintingRoundDefectsView />;
}
